import React from 'react';
import { motion } from 'framer-motion';

interface ScheduleToggleProps {
  isScheduled: boolean;
  onToggle: (value: boolean) => void;
}

export const ScheduleToggle: React.FC<ScheduleToggleProps> = ({
  isScheduled,
  onToggle,
}) => {
  return (
    <div className="flex items-center gap-3">
      <span className="text-sm font-medium text-gray-700">
        Schedule for later
      </span>
      
      {/* Animated Toggle */}
      <button
        type="button"
        onClick={() => onToggle(!isScheduled)}
        className={`relative w-14 h-7 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ${
          isScheduled ? 'bg-red-500' : 'bg-gray-300'
        }`}
        aria-label="Toggle schedule pickup"
        aria-pressed={isScheduled}
      >
        {/* Animated Thumb */}
        <motion.div
          className="absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow-md"
          animate={{
            x: isScheduled ? 28 : 0,
          }}
          transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30,
          }}
        />
      </button>
      
      {/* Status Text */}
      <span className={`text-xs font-medium ${
        isScheduled ? 'text-red-500' : 'text-gray-400'
      }`}>
        {isScheduled ? 'ON' : 'OFF'}
      </span>
    </div>
  );
};
